const getPartCountEvents = (store) => {
  return store.partCountEvents;
};

export { getPartCountEvents };
